import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Menucontrol from '../menucontrol';
import Settingss from '../settings';
import Parts from '../parts';
import BankDetails from '../AppMaster/BankDetails';
import UPIDetails from '../AppMaster/upidetails';
import Labor from '../JobCard/Labor';
import Addmenu from '../addmenu';
import Editbranch from '../editbranch';
import HSNCodeReport from '../Accountings/HSNCodeReport';
import DiscountMenu from '../WebMaster/DiscountMenu';
import StockTransfer from '../Sales/StockTransfer';
import Combo from '../addmenu/Combo';
import Purchaser from '../purchaser';
import Icon from '@material-ui/core/Icon';
import PurchaseDetails from '../PurchaseAndStock/PurchaseDetails';
import ServiceType from '../JobCard/ServiceType';
import ServiceHistory from '../JobCard/ServiceHistory';
import PurchaseRequest from '../PurchaseAndStock/PurchaseRequest';
import Offers from '../AppMaster/offer';
import Stockinfo from '../stockinfo';
import Placeorder from '../Sales/PlaceOrder';
import Tickets from '../tickets';
import Sms from '../WebMaster/SMS';
import Statements from '../Sales/CustomerStatement';
import Stockaudit from '../stockaudit';
import Controls from '../AdminControl/WebAccess';
import Dashboard from '../dashboard';
import ExpenseReport from '../Accountings/ExpenseReport';
import Addcustomer from '../WebMaster/AddCustomer';
import Receipt from '../Accountings/Receipt';
import JobCard from '../JobCard/JobCard';
import Quotation from '../Sales/Quotation/newquotation';


import Machine from '../machine/machineinfo';
import Machinecustomer from '../machine/machinecustomer';
import EnquiryCustomer from '../machine/EnquiryCustomer';
import Machinesales from '../machine/machinesales';
import MachineReceipt from '../machine/receipt';
import MachinePayment from '../machine/payment';
import MachineCustomerStatement from '../machine/statement';
import Model from '../machine/model';

import Invoice from '../Sales/Invoice';
import ExecutiveBranch from '../executivebranch';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import SelectBranch from '../selectbranch';
import ReadCookie from '../../functions/readcookies';
import $ from "jquery";
import Server from '../../functions/server';
import Logo from '../media/logo.png';
import Chitta from '../Accountings/Chitta';
import { Image } from 'semantic-ui-react';

import Analytics from '../analytics';
import ResetPassword from '../login/resetpassword';
import ChartDashboard from '../dashboard/ChartDashBoard';
import ExecutiveAppBranch from '../AppMaster/executiveappbranch';
import ModeControl from '../modecontrol';
import AppModeControl from '../AppMaster/appmodecontrol';
import BrandControl from '../brandcontrol';
import StatementMapping from '../statementmapping';
import Accounting from '../Accountings/Journal';
import GSTSalesReport from '../Accountings/GSTSalesReport';
import GSTPurchaseReport from '../Accountings/GSTPurchaseReport';

import SalesType from '../Sales/SalesReport';
import DualScreenPlaceOrder from '../Sales/CustomerOrder';
import EmployeeDetails from '../AdminControl/Executive';
import ExpenseMaster from '../WebMaster/ExpenseMaster';
import ExpenseDetails from '../Expensedetails';
import Expense from '../Accountings/Expense';
import PurchaserStatement from '../PurchaseAndStock/PurchaserStatement';
import DebitNotes from '../PurchaseAndStock/DebitNotes';
import CreditNote from '../Sales/CreditNote';
import Payment from '../Accountings/Payment';
import CustomerType from '../customerType';
import CustomerTypeMapping from '../customerTypeMapping';

import Notification from '../AdminControl/Notification';
import Release from '../../functions/release';
import JobCardReport from '../JobCard/JobCardReport';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,

    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
});

class PersistentDrawerLeft extends React.Component {
  state = {
    open: true, key: '', opens: true, number: 0, menus: [], expanded: 'panel',
    offers: 0, addmenu: false, value: 0
  };

  componentDidMount() {
    let context = this;
    this.getmenus();
    $(window).bind('beforeunload', function(){
      myfun();
      return 'Are you sure you want to leave?';
    });
    function myfun() {
      $.ajax({
        type: 'POST',
        data: { 'userId': context.state.userId },
        url: Server() + 'login/exit.php',
      });
    }
  }

  getmenus() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.role_id;
    let data1 = { 'id' : userId }
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'executivemenu/getcontrol.php',
      success: function(data) {

        try {
          data = JSON.parse(data);
          context.addtoCookies(data);
          context.setState({ menus: data, userId: userId })
        } catch (e) {
        }
      },
      error: function(err) {
        alert('JSON.stringify(err)');
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
   }

   addtoCookies(data) {
     this.setState({ items: data });
     let menus = [];
     data.map((x) => {
       if (x.type == 'menucontrol') {
         menus.push((x));
       }
     })
     menus = JSON.stringify(menus);
     localStorage.setItem('menus', menus);
   }


  render() {
    const { classes, theme } = this.props;
    const { open, key } = this.state;
    return (
      <Router>
        <div className={classes.root}>
          <SelectBranch  />
          { this.state.menus.length > 0 ?
            (
                <main className={classNames(classes.content, {[classes.contentShift]: open,})}>
                  <Switch>
                    <Route exact path={"/"+Release()+"/"} component={() => <Dashboard menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/dashboard"} component={() => <Dashboard menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/chart-dashboard"} component={() => <ChartDashboard menus={this.state.menus} />}/>

                    <Route exact path={"/"+Release()+"/place-order"} component={() => <Placeorder menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/customer-order"} component={() => <DualScreenPlaceOrder  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/quotation"} component={() => <Quotation menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/invoice"} component={() => <Invoice menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/job-card"} component={() => <JobCard menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/job-card-report"} component={() => <JobCardReport menus={this.state.menus} />}/>



                    <Route exact path={"/"+Release()+"/credit-note"} component={() => <CreditNote  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/stock-transfer"} component={() => <StockTransfer menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/sales-report"} component={() => <SalesType  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/customer-statement"} component={() => <Statements menus={this.state.menus} />}/>

                    <Route exact path={"/"+Release()+"/purchase-request"} component={() => <PurchaseRequest menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/purchase-details"} component={() => <PurchaseDetails menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/stock-level"} component={() => <Editbranch  menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/debit-notes"} component={() => <DebitNotes  menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/stock-info"} component={() => <Stockinfo menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/analytics"} component={() => <Analytics menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/stock-audit"} component={() => <Stockaudit menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/purchaser-statement"} component={() => <PurchaserStatement  menus={this.state.menus} />} />

                    <Route exact path={"/"+Release()+"/receipt"} component={() => <Receipt menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/payment"} component={() => <Payment  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/expense"} component={() => <Expense  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/chitta"} component={() => <Chitta  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/journal"} component={() => <Accounting menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/expense-report"} component={() => <ExpenseReport  menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/hsncode-report"} component={() => <HSNCodeReport  menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/gst-sales-report"} component={() => <GSTSalesReport  menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/gst-purchase-report"} component={() => <GSTPurchaseReport  menus={this.state.menus} />}/>

                    <Route exact path={"/"+Release()+"/machine"} component={() => <Model menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/machine-model"} component={() => <Machine menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/machine-customer"} component={() => <Machinecustomer menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/enquiry-customer"} component={() => <EnquiryCustomer menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/machine-quotation"} component={() => <Machinesales menus={this.state.menus} type={'Quotation'} />}/>
                    <Route exact path={"/"+Release()+"/machine-invoice"} component={() => <Machinesales menus={this.state.menus} type={'Invoice'} />}/>
                    <Route exact path={"/"+Release()+"/machine-receipt"} component={() => <MachineReceipt menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/machine-payment"} component={() => <MachinePayment menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/machine-customer-statement"} component={() => <MachineCustomerStatement menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/service-type"} component={() => <ServiceType menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/service-history"} component={() => <ServiceHistory menus={this.state.menus} />} />

                    <Route exact path={"/"+Release()+"/add-parts"} component={() => <Parts menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/add-customer"} component={() => <Addcustomer menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/add-purchaser"} component={() => <Purchaser menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/combo"} component={() => <Combo from={"router"} menuPermission={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/expense-master"} component={() => <ExpenseMaster  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/executive-web-branch-mapping"} component={() => <ExecutiveBranch menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/web-payment-mode-mapping"} component={() => <ModeControl menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/discount-menu"} component={() => <DiscountMenu menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/sms"} component={() => <Sms menus={this.state.menus} />}/>


                    <Route exact path={"/"+Release()+"/executive-control"} component={() => <Menucontrol menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/executive-app-branch-mapping"} component={() => <ExecutiveAppBranch menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/app-payment-mode-mapping"} component={() => <AppModeControl menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/edit-bank-details"} component={() => <BankDetails menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/edit-upi-details"} component={() => <UPIDetails menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/offers-scroll"} component={() => <Offers menus={this.state.menus} />}/>

                    <Route exact path={"/"+Release()+"/executive"} component={() => <EmployeeDetails  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/labor"} component={() => <Labor  menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/add-menu"} component={() => <Addmenu menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/brand-control"} component={() => <BrandControl menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/customer-type"} component={() => <CustomerType menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/customer-type-mapping"} component={() => <CustomerTypeMapping menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/notification"} component={() => <Notification menus={this.state.menus} />} />
                    <Route exact path={"/"+Release()+"/point-settings"} component={() => <Settingss menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/statement-mapping"} component={() => <StatementMapping  menus={this.state.menus} />}/>


                    <Route exact path={"/"+Release()+"/web-access"} component={() => <Controls menus={this.state.menus} />}/>
                    <Route exact path={"/"+Release()+"/tickets"} component={() => <Tickets menus={this.state.menus} />}/>

                  </Switch>
                </main>
            ): (<center>Loading...</center>)
          }
        </div>
      </Router>
    );
  }
}

PersistentDrawerLeft.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(PersistentDrawerLeft);
